import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faEnvelopeOpen } from "@fortawesome/free-solid-svg-icons";
import AppHeader from "./layouts/AppHeader";
import FooterNav from "./FooterNav";

const Contact = (props) => {
  return (
    <>
      <div id="codekali_wrapper">
        <AppHeader />

        <div className="container">

              <div className="row g-4 mt-4">
              <div className="col-md-4">
                <div className="card text-center shadow-sm h-100 codekali-round bg-dark text-white">
                  <div className="card-body">
                    <FontAwesomeIcon className="contact-icon text-info mb-3" icon={faPhone} />
                    <h3 className="card-title codekali-bold">Call Us</h3>
                    <p className="card-text text-white">+254 700 422 699</p>
                    <a href="tel:++254700422699" className="btn mb-3 btn-outline-warning">Call Now</a>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="card text-center shadow-sm h-100 codekali-round bg-dark text-white">
                  <div className="card-body">
                    <FontAwesomeIcon className="contact-icon text-info mb-3" icon={faWhatsapp} />
                    <h3 className="card-title codekali-bold">WhatsApp</h3>
                    <p className="card-text text-white">+254 700 422 699</p>
                    <a
                    href="https://wa.me/254700422699?text=Hello%20Codekali%20Developers,%20I%20would%20like%20to%20hire%20your%20development%20services%20in%20relation%20to%20the%20following:"

                      target="_blank"
                        rel="noreferrer"
                      className="btn mb-3 btn-outline-warning"
                    >
                      WhatsApp Now
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="card text-center shadow-sm h-100 codekali-round bg-dark text-white h-100 codekali-round bg-dark text-white">
                  <div className="card-body">
                    <FontAwesomeIcon className="contact-icon text-info mb-3" icon={faEnvelopeOpen} />
                    <h3 className="card-title codekali-bold">Email Us</h3>
                    <p className="card-text text-white">developers@codekali.com</p>
                    <a href="mailto:developers@codekali.com" className="btn mb-3 btn-outline-warning">
                      Send Email
                    </a>
                  </div>
                </div>
              </div>
            </div>
        

          <FooterNav />
        </div>
      </div>
    </>
  );
};

export default Contact;
